export default {
      id: "i-logo-white-usage",
      viewBox: "0 0 187 52",
      url: __webpack_public_path__ + "img/sprite.svg#i-logo-white",
      toString: function () {
        return this.url;
      }
    }